import { useContext } from "react";
import PropTypes from "prop-types";
import { LuxeContext } from "@context/LuxeProvider";

import PerksTable from "@components/sideCart/luxeSelection/PerksTable";

import { withALErrorBoundary } from "@helpers/ErrorBoundary/ALErrorBoundary";

function LuxeSelection({ sideCartInfo }) {
  const { luxe } = useContext(LuxeContext);

  if (!luxe.isLuxeEnabled) return null;

  const hasSolidGoldProduct = sideCartInfo.lines?.some((line) =>
    line.variant?.product?.tags?.includes("Components:10K Solid Gold")
  );
  let luxeMessage = "AL Luxe Member";
  if (hasSolidGoldProduct) {
    luxeMessage = "AL Luxe Member - 5% off Solid Gold";
  }

  if (luxe.customerSubscription && luxe.customerSubscription.status === "ACTIVE") {
    return (
      <div className="m-[20px] mobile:m-[15px] p-[15px] border border-black rounded-[4px]">
        <p className="typo-body font-bold text-secondary mb-[5px]">{luxeMessage}</p>
        <p className="typo-body">
          Balance: <b>${luxe.subscriptionCredit} in credits</b> (apply at checkout)
        </p>
      </div>
    );
  }

  return <PerksTable sideCartInfo={sideCartInfo} />;
}

LuxeSelection.propTypes = {
  sideCartInfo: PropTypes.object.isRequired,
};

export default withALErrorBoundary({
  name: "SideCart",
  priority: "P1",
})(LuxeSelection);
